'use strict';

export class AndroidKeyboardCloseDetector {
	/**
	 * @param {Function} on_close - Callback on keyboard close detected.
	 * @param {Object} options
	 * @param {number} options.threshold - Height increase to detect closure.
	 */
	constructor(on_close, options = {}) {
		if (typeof on_close !== 'function') {
			throw new Error('on_close callback required');
		}
		
		this.on_close = on_close;
		this.threshold = options.threshold || 100;
		
		this._last_height = 0;
		
		this._visual_viewport_listener = false;
		this._resize_observer = null;
		
		this._handle_visual_viewport_resize = this._handle_visual_viewport_resize.bind(this);
		this._handle_resize_observer = this._handle_resize_observer.bind(this);
		// prebind this context
		this.start = this._start.bind(this);
		this.stop = this._stop.bind(this);
	}
	
	_start(event) {
		jQuery(event.currentTarget).off('blur', this._stop).on('blur', this._stop);
		this._last_height = this._get_current_height();
		if (window.visualViewport && window.visualViewport.addEventListener) {
			// Iit tracks the visual viewport size changes very accurately.
			window.visualViewport.addEventListener('resize', this._handle_visual_viewport_resize);
			this._visual_viewport_listener = true;
			return;
		}
		
		if (typeof ResizeObserver !== 'undefined') {
			// Fallback to observing document.documentElement size changes,
			// which may sometimes reflect keyboard opening/closing.
			this._resize_observer = new ResizeObserver(this._handle_resize_observer);
			this._resize_observer.observe(document.documentElement);
		}
	}
	
	_stop(event) {
		jQuery(event.currentTarget).off('focus', this._start).on('focus', this._start);
		if (this._visual_viewport_listener && window.visualViewport) {
			window.visualViewport.removeEventListener('resize', this._handle_visual_viewport_resize);
			this._visual_viewport_listener = false;
		}
		
		if (this._resize_observer) {
			this._resize_observer.disconnect();
			this._resize_observer = null;
		}
	}
	
	_get_current_height() {
		if (window.visualViewport) {
			return window.visualViewport.height;
		}
		return window.innerHeight || document.documentElement.clientHeight;
	}
	
	_handle_visual_viewport_resize() {
		const current_height = window.visualViewport.height;
		if (current_height > this._last_height + this.threshold) {
			this._trigger_close();
		}
		this._last_height = current_height;
	}
	
	_handle_resize_observer(entries) {
		for (const entry of entries) {
			const cr = entry.contentRect;
			const height = cr.height;
			
			if (height > this._last_height + this.threshold) {
				this._trigger_close();
				break;
			}
			
			this._last_height = height;
		}
	}
	
	_trigger_close() {
		this.on_close();
	}
}

